import adapter from './adapter'
import componentStatus from './actions/component-status'
import featuresStore from './features-store'
import getData from './actions/get-data'
import handshake from './actions/handshake'
import isLoaded from './is-loaded'
import isSupported from './is-supported'
import merchantEvent from './actions/merchant-event'
import putData from './actions/put-data'
import showInternalBrowser from './actions/show-internal-browser'
import showSandboxedInternalBrowser from './actions/show-sandboxed-internal-browser'

export const Feature = {
  // Add features here
}

const runHandshake = handshake(adapter, featuresStore)

// Run the handshake at most once. Both the bootstrap `handshake()` call and any
// `whenReady()` gate share this single promise, so feature support is never
// fetched more than once regardless of how often either is called.
let handshakePromise = null
const startHandshake = () => (handshakePromise = handshakePromise || runHandshake())

// Resolves once feature support is known, starting the handshake if it hasn't
// run yet. Settles on success or failure so consumers never hang. When the SDK
// is not supported there is no handshake, so resolve immediately.
const whenReady = () =>
  isSupported()
    ? startHandshake().then(
        () => {},
        () => {}
      )
    : Promise.resolve()

// Feature support is populated by the async handshake, so await readiness
// before reading the store. This keeps the race handling internal — callers
// just `await isFeatureSupported(...)` and never need to gate on readiness
// themselves.
const isFeatureSupported = async feature => {
  await whenReady()
  return featuresStore.has(feature)
}

export default {
  getData: getData(adapter),
  handshake: startHandshake,
  putData: putData(adapter),
  componentStatus: componentStatus(adapter),
  showInternalBrowser: showInternalBrowser(adapter),
  showSandboxedInternalBrowser: showSandboxedInternalBrowser(adapter),
  merchantEvent: merchantEvent(adapter),
  init: adapter.init,
  isFeatureSupported,
  getFeatures: featuresStore.get,
  isLoaded,
  isSupported
}
